/**
 * The per-item result of an operation (design M8) as the words a results row
 * shows. Plain data for the reason `component-card.ts` gives.
 */

export type ItemResult = 'turned' | 'already' | 'failed' | 'archived';

const LABEL: Record<ItemResult, string> = {
    turned: 'Turned',
    already: 'Already in that state',
    failed: 'Failed',
    archived: 'Archived, skipped',
};

export function itemResultLabel(result: ItemResult): string {
    return LABEL[result];
}
